export default [
  {
    path: '',
    name: 'role list',
    component: () => import('@/views/app/role/page-list.vue'),
    meta: { title: 'Daftar Hak Akses' },
  },
]
